<template>
    <div class="card-input-c2p mx-auto">
        <div class="card-input-brand" v-if="cardBrand">
            <CardBrand data-dd-privacy="mask" :brand="cardBrand" tabindex="-1" />
        </div>
        <CieloInputV2
            class="mx-auto"
            :autofocus="true"
            :borderless="false"
            name="CreditCardNumber"
            :label="$ml.get('cardNumber')"
            @input="(value) => $emit('input', value)"
            :value="value"
            v-validate="'required|numeric|min:12|max:19|luhn-chk'"
            :data-vv-as="$ml.get('cardNumber')"
            :error="errors.first('CreditCardNumber') || cardError"
            type="tel"
            :mask="['#### #### #### #### #####']"
        />
    </div>
</template>
  
<script>
const CieloInputV2 = () => import(
        /* webpackChunkName: "cielo-input" */ '@/components/ClickToPay/template/CieloInputV2'
);
import LuhnAlgorithm from '@/helpers/validation-rules/LuhnAlgorithm';
import CardBrand from '@/components/CardBrand';

export default {
    components: {
        CardBrand,
        CieloInputV2,
    },

    mounted() {
        this.$validator.extend('luhn-chk', LuhnAlgorithm);
    },

    watch: {
        isValidErrors() {
            this.$validator.validate();
        },
    },

    props: {
        value: {
            type: String,
            default: ''
        },
        cardBrand: {
            type: String,
            default: ''
        },
        cardError: {
            type: String,
            default: ''
        },
        isValidErrors: {
            type: Boolean,
        }
    },
};

</script>
  
<style lang="css" scoped>
.card-input-c2p {
    position: relative;
}

.card-input-brand {
    position: absolute;
    top: 16px;
    right: 16px;
    width: 36px;
    height: 23px;
    border-radius: 4px;
    z-index: 2;
}
</style>